import React, { useCallback } from "react";
import { get, has, noop } from "lodash";
import { useSelector, useDispatch } from "react-redux";
import ModalV2 from "@tvg/atomic-ui/_templates/ModalV2";
import RegistrationLegalContent from "@tvg/atomic-ui/_templates/RegistrationLegalContent";

import {
  handleLegalContentButton,
  handleLegalContentLinks
} from "../utils/handlers";
import {
  handleLegalContentModalRegistrationAction,
  setLegalContentModalOriginRegistrationAction
} from "../actions";
import {
  getLegalContentContentType,
  getLegalContentIsModalOpen,
  getLegalContentModalOrigin,
  getLegalContentPrivacyPolicy,
  getLegalContentTermsAndConditions,
  getRegistrationTexts
} from "../utils/selectors";

export const LegalContentModal = ({ device }) => {
  const dispatch = useDispatch();

  const isModalOpen = useSelector(getLegalContentIsModalOpen);
  const contentType = useSelector(getLegalContentContentType);
  const modalOrigin = useSelector(getLegalContentModalOrigin);
  const registrationTexts = useSelector(getRegistrationTexts);
  const privacyPolicy = useSelector(getLegalContentPrivacyPolicy);
  const termsAndConditions = useSelector(getLegalContentTermsAndConditions);

  const legalContent = {
    privacyPolicy,
    termsAndConditions
  };

  const isMobile = device === "mobile";
  const modalTitle = get(
    registrationTexts,
    `modals.legalContent.modalTitle.${contentType}`,
    ""
  );
  const validContentTypes = has(
    registrationTexts,
    "modals.legalContent.modalTitle"
  )
    ? Object.keys(get(registrationTexts, "modals.legalContent.modalTitle"))
    : [];

  const closeModal = useCallback(() => {
    dispatch(setLegalContentModalOriginRegistrationAction(""));
    dispatch(
      handleLegalContentModalRegistrationAction({
        isOpen: false,
        contentType: ""
      })
    );
  }, []);

  const handleOnBack = useCallback(() => {
    dispatch(
      handleLegalContentModalRegistrationAction({
        isOpen: true,
        contentType: modalOrigin
      })
    );
  }, [modalOrigin]);

  return (
    <ModalV2
      title={modalTitle}
      titleType="ipp"
      isOpen={isModalOpen}
      hasCloseButton
      onClose={() => closeModal(dispatch)}
      onOverlayClick={() => closeModal(dispatch)}
      qaLabel="modal-legal-content"
      animation={isMobile ? "bottom" : "bottomFloating"}
      offsetLeft={isMobile ? 0 : 12}
      offsetRight={isMobile ? 0 : 12}
      fixedWidth={isMobile ? "100%" : "728px"}
      isFullWidth={isMobile}
      hasContentMaxHeight
      offsetTop={66}
      onBack={contentType !== modalOrigin ? handleOnBack : undefined}
    >
      {() => (
        <RegistrationLegalContent
          contentType={contentType}
          isMobile={isMobile}
          content={legalContent[contentType]}
          handleLegalContentButton={handleLegalContentButton(dispatch)}
          handleLegalContentLinks={handleLegalContentLinks}
          modalOrigin={modalOrigin}
          validContentTypes={validContentTypes}
        />
      )}
    </ModalV2>
  );
};

LegalContentModal.defaultProps = {
  contentType: "termsAndConditions",
  device: "mobile",
  dispatch: noop,
  isModalOpen: false,
  legalContent: {
    privacyPolicy: "",
    termsAndConditions: ""
  },
  registrationTexts: {
    modals: {
      legalContent: {
        modalTitle: {
          privacyPolicy: "",
          termsAndConditions: ""
        }
      }
    }
  }
};

const areEqual = (prevProps, nextProps) =>
  prevProps.contentType === nextProps.contentType;

export default React.memo(LegalContentModal, areEqual);
